<template>
  <div class="mt-3 mt-md-4">
    <div
      v-for="(room, index) in cartItem.roomOptions"
      :key="index"
      :class="`${index !== 0 ? 'mt-3' : ''}`"
    >
      <div class="font-size-sm font-weight-bold color-text-dark">
        {{ i18n.roomOptions }} #{{ index + 1 }} ({{ room.amountOfPersons }} {{ room.amountOfPersons === 1 ? 'persoon' : 'personen' }})
      </div>

      <div
        v-for="(roomOption, roomOptionIndex) in room.options"
        :key="roomOptionIndex"
        class="accommodation-option mt-3"
      >
        <input
          type="radio"
          :id="`room-option-${index}-${roomOption.id}-${roomOptionIndex}`"
          :name="`room-option-${index}-${roomOption.id}`"
          :value="roomOption.id"
          :checked="room.selectedOption === roomOption.id"
          @change="() => onRoomOptionChange(index, cartItem, roomOption)"
        >

        <label :for="`room-option-${index}-${roomOption.id}-${roomOptionIndex}`">
          {{ roomOption.description }}

          <span class="color-primary font-weight-bold">
            <template v-if="roomOption.price !== null">
              {{ (roomOptionIndex !== 0) ? (roomOption.price >= 0 ? '+ ' : '- ') : '' }}{{ formattedPrice(roomOption.price) }}
            </template>
            <template v-else>
              {{ i18n.priceOnRequest }}
            </template>
          </span>
        </label>

        <button
          type="button"
          class="tooltip-toggler accommodation-option__info btn--reset"
          data-toggle="modal"
          :data-target="`#roomModal-${cartItem.id}-${index}-${roomOptionIndex}`"
        >
          <Icon name="info" extra-classes="tooltip-icon" />
        </button>

        <RoomModal
          :id="`roomModal-${cartItem.id}-${index}-${roomOptionIndex}`"
          :title="roomOption.description"
          :text="roomOption.text"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import formatPrice from '@/helpers/formatPrice';
import Icon from '@/cart/components/Icon.vue';
import RoomModal from '@/cart/components/RoomModal.vue';

export default {
  components: {
    RoomModal,
    Icon,
  },

  props: {
    cartItem: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions([
      'onCartItemRoomOptionChange',
    ]),

    ...mapMutations([
      'setSelectedRoomOptionForCartItem',
    ]),

    onRoomOptionChange(index, cartItem, roomOption) {
      this.setSelectedRoomOptionForCartItem([index, cartItem, roomOption.id]);
      this.onCartItemRoomOptionChange([index, cartItem, roomOption.id])
    },

    formattedPrice(price) {
      return `${formatPrice(Math.abs(price), 0, '€')},-`;
    }
  },
};
</script>
